import { IDiscount } from '@/interfaces/IDiscount';
import axios from 'axios';
import { DiscountType } from '@/enums/DiscountType';
import { Globals } from '@/modules/Globals';

const apiUrl = Globals.apiPath + '/orders';
const tableSessionsApiUrl = Globals.apiPath + '/v2/table-sessions';

interface CreateDiscountDto {
  orderId: number;
  type: DiscountType;
  isPercentage: boolean;
  value: number;
  referenceId?: number | null;
  metadata?: Record<string, any> | null;
}

interface UpdateDiscountDto {
  isPercentage?: boolean;
  value?: number;
  metadata?: Record<string, any> | null;
}

export interface ITableSessionDiscountResult {
  sessionId: string;
  isPercentage: boolean;
  value: number;
  appliedOrderIds: number[];
  totalDiscounted: number;
}

export interface ITableSessionDiscountRemoveResult {
  sessionId: string;
  removedFromOrderIds: number[];
}

export default class DiscountsService {
  static async list(orderId: number): Promise<IDiscount[]> {
    const response = await axios.get(`${apiUrl}/${orderId}/discounts`);
    return response.data.data || response.data;
  }

  static async create(data: CreateDiscountDto): Promise<IDiscount> {
    const { orderId, ...payload } = data;
    const response = await axios.post(
      `${apiUrl}/${orderId}/discounts`,
      payload
    );
    return response.data.data || response.data;
  }

  static async update(
    orderId: number,
    discountId: number,
    data: UpdateDiscountDto
  ): Promise<IDiscount> {
    const response = await axios.put(
      `${apiUrl}/${orderId}/discounts/${discountId}`,
      data
    );
    return response.data.data || response.data;
  }

  static async delete(orderId: number, discountId: number): Promise<void> {
    await axios.delete(`${apiUrl}/${orderId}/discounts/${discountId}`);
  }

  static async setTableSessionDiscount(
    tableSessionId: string,
    data: { isPercentage: boolean; value: number }
  ): Promise<ITableSessionDiscountResult> {
    const response = await axios.put(
      `${tableSessionsApiUrl}/${tableSessionId}/discount`,
      data
    );
    return response.data.data || response.data;
  }

  static async removeTableSessionDiscount(
    tableSessionId: string
  ): Promise<ITableSessionDiscountRemoveResult> {
    const response = await axios.delete(
      `${tableSessionsApiUrl}/${tableSessionId}/discount`
    );
    return response.data.data || response.data;
  }
}
